export default "__VITE_ASSET__CrYsQGXU__"